import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EuiButtonModule } from '../../components/eui-button';
import { EuiDropdownModule } from '../../components/eui-dropdown';
import { EuiLanguageSelectorComponent } from './language-selector.component';
import { EuiModalSelectorComponent } from './modal-selector/modal-selector.component';

@NgModule({
    imports: [
        CommonModule,
        EuiDropdownModule,
        EuiButtonModule,
    ],
    exports: [
        EuiLanguageSelectorComponent,
    ],
    declarations: [
        EuiLanguageSelectorComponent,
        EuiModalSelectorComponent,
    ],
})
export class EuiLanguageSelectorModule {
}
